// extracted by mini-css-extract-plugin
export default {"wrapper":"kY-z","availablePromoMessagesLabel":"lY-z","promoMessageList":"mY-z","promoMessage":"nY-z","appliedPromoMessage":"oY-z","promoMessageAmount":"pY-z"};